import React from 'react'

import { Icon } from '@app/components/util'
import { LntBadge, LntIconButton } from '@app/components/base'

import { ICON_NAME } from '@app/constants/icon'
import { BUTTON_TYPE, ICON_SIZE, SIZE } from '@app/constants'

import type { NotificationButtonProps } from './types'

const NotificationOutlined: React.FC = () => (
  <Icon
    size={ ICON_SIZE }
    name={ ICON_NAME.notification }
  />
)

export const NotificationButton: React.FC<NotificationButtonProps> = ({ hasNotification, onOpenNotificationMenu }) => {
  const buttonIcon = (
    <LntBadge dot={ hasNotification }>
      <NotificationOutlined />
    </LntBadge>
  )

  return (
    <LntIconButton
      type={ BUTTON_TYPE.text }
      size={ SIZE.middle }
      icon={ buttonIcon }
      onClick={ onOpenNotificationMenu }
    />
  )
}
